export default "__VITE_ASSET__CTC8kRwi__"